'use client';

import {
  Button,
  Dropdown,
  DropdownTrigger,
  DropdownMenu,
  DropdownItem,
} from '@heroui/react';
import { FaEllipsisVertical } from 'react-icons/fa6';
import type { QuoteActionItem, QuoteActionKey } from './quoteEntryUtils';

export default function QuoteEntryActionsDropdown({
  items,
  onAction,
  portalContainer,
}: {
  items: QuoteActionItem[];
  onAction: (key: QuoteActionKey) => void;
  portalContainer?: Element;
}) {
  if (items.length === 0) return null;

  return (
    <Dropdown
      placement='bottom-end'
      portalContainer={portalContainer}
      shouldBlockScroll={false}
      classNames={{
        content: 'z-[10000000]',
      }}
    >
      <DropdownTrigger>
        <Button
          size='sm'
          variant='light'
          endContent={<FaEllipsisVertical size={12} />}
          color='default'
          className='text-xs font-bold uppercase'
        >
          Actions
        </Button>
      </DropdownTrigger>
      <DropdownMenu
        aria-label='Quote actions'
        onAction={(key) => onAction(key as QuoteActionKey)}
      >
        {items.map((item) => (
          <DropdownItem key={item.key} startContent={item.startContent} className='text-xs'>
            {item.label}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
}
